module.exports = __webpack_public_path__ + "img/background-logo.bb7eac9f.svg";